import React from 'react'
import Typography from '@mui/material/Typography'
import styled from 'styled-components'

// The use of `!important` is necessary to ensure styles are applied as expected in standalone deployments
const TextTypography = styled(Typography)`
  font-size: 2.125rem !important;
  font-weight: 400 !important;
  line-height: 1.235 !important;
  letter-spacing: 0.00735em !important;
  margin-top: 2.188rem !important;
`

const HeaderText = () => (
  <TextTypography variant="h1" display="block">
    Text analysis
  </TextTypography>
)

export { HeaderText }
